/* Devroldan */
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { AppState as State } from './state.interface';
import * as fromAuth from '../core/auth/reducer/auth.reducer';
import * as fromAccount from '../core/account/reducer/account.reducer';
import * as fromProductControl from '../core/product-control/reducer/product-control.reducer';
import * as fromCommon from '../core/common/reducer/common.reducer';
import * as fromList from '../core/lists/reducer/lists.reducer';
import { environment } from '../environments/environment';
import { direccionesReducer } from './clientes/reducer/direccion.reducer';
import { imagenDisenioReducer } from './clientes/reducer/disenio-imagen.reducer';
import { adjuntosDisenioImagenReducer } from './clientes/reducer/adjuntos-disenio-imagen.reducer';

export const reducers: ActionReducerMap<State> = {
  auth: fromAuth.reducer,
  account: fromAccount.reducer,
  productControl: fromProductControl.reducer,
  common: fromCommon.reducer,
  list: fromList.reducer,
  direcciones:direccionesReducer,
  imagenDisenio:imagenDisenioReducer,
  adjuntosDisenioImagen:adjuntosDisenioImagenReducer,
};

export function logger(reducer: ActionReducer<State>): ActionReducer<any, any> {
  return function(state: State, action: any): State {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [logger]
  : [];
